<template>
  <div class="col-lg-6">
    <div class="card">
      <!-- <div class="card-header">
        <h4 class="card-title">Promjena lozinke</h4>
      </div> -->
      <div class="card-body custom-alert">
        <b-alert
          v-model="deviceAlredyExists"
          v-height-fade.appear
          variant="danger"
          dismissible
          class="mb-0"
        >
          <div class="alert-body">
            Uređaj sa unijetim ID-om već postoji!
          </div>
        </b-alert>
      </div>
      <div class="card-body">
        <validation-observer ref="passwordForm">
          <b-form @submit.prevent="submitForm">
            <b-row>
              <!-- ID UREDJAJA -->
              <b-col cols="12">
                <b-form-group
                  label="ID uređaja"
                  label-for="deviceId"
                  label-cols-md="4"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="deviceId"
                    vid="deviceId"
                    rules="required"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="KeyIcon" />
                      </b-input-group-prepend>

                      <b-form-input
                        v-model="device.pkDeviceId"
                        id="deviceId"
                        type="text"
                        placeholder="ID uređaja"
                        :disabled="$route.params.id"
                      />
                    </b-input-group>
                    <div class="text-danger">{{ errors[0] }}</div>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- NAZIV UREDJAJA -->
              <b-col cols="12">
                <b-form-group
                  label="Naziv uređaja"
                  label-for="deviceName"
                  label-cols-md="4"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="deviceName"
                    vid="deviceName"
                    rules="required"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="InfoIcon" />
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="device.name"
                        id="deviceName"
                        type="text"
                        placeholder="Naziv uređaja"
                      />
                    </b-input-group>
                    <div class="text-danger">{{ errors[0] }}</div>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- NAPON BATERIJE -->
              <b-col cols="12">
                <b-form-group
                  label="Napon baterije"
                  label-for="deviceName"
                  label-cols-md="4"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="deviceVoltage"
                    vid="deviceVoltage"
                    rules="required"
                  >
                    <b-input-group class="input-group-merge">
                      <b-form-input
                        v-model="device.maxVoltage"
                        id="deviceVoltage"
                        type="number"
                        step="0.1"
                        placeholder="Maksimalni napon baterije"
                      />
                    </b-input-group>
                    <div class="text-danger">{{ errors[0] }}</div>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- submit and reset -->
              <b-col offset-md="4">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                >
                  Sačuvaj
                </b-button>
                <b-button
                  v-if="!$route.params.id"
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="reset"
                  variant="outline-secondary"
                  ref="resetButton"
                >
                  Poništi
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BInputGroup,
  BInputGroupPrepend,
  BRow,
  BCol,
  BAlert,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import { heightFade } from "@core/directives/animations";
import { required, min, confirmed } from "@validations";
import store from "@/store/index";
import { mapState } from "vuex";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BAlert,
  },
  directives: {
    "height-fade": heightFade,
    Ripple,
  },
  beforeRouteEnter(to, from, next) {
    let getDeviceById = null;

    if (!to.params.id) {
      to.meta.pageTitle = "Dodavanje uređaja";
      to.meta.breadcrumb[1].text = "Dodavanje uređaja";
      store.commit("devices/SET_DEVICE");
    } else {
      getDeviceById = store.dispatch("devices/GET_DEVICE_BY_ID", to.params.id);
      to.meta.pageTitle = "Izmjena uređaja";
      to.meta.breadcrumb[1].text = "Izmjena uređaja";
    }

    Promise.all([getDeviceById]).then(() => {
      next();
    });
  },
  beforeDestroy() {
    store.commit("devices/SET_DEVICE");
  },
  data() {
    return {
      deviceAlredyExists: false,
    };
  },
  mounted() {
    localize("en", {
      code: "en",
      fields: {
        deviceId: {
          required: "Polje je obavezno",
        },
        deviceName: {
          required: "Polje je obavezno",
        },
        deviceVoltage: {
          required: "Polje je obavezno",
        },
      },
    });
  },
  computed: {
    ...mapState({
      device: (state) => state.devices.device,
    }),
  },
  methods: {
    submitForm() {
      var $this = this;
      $this.deviceAlredyExists = false;
      this.$refs.passwordForm.validate().then((success) => {
        if (success) {
          if (!this.$route.params.id) this.addDevice();
          else this.updateDevice();
        }
      });
    },
    addDevice() {
      var $this = this;
      store
        .dispatch("devices/ADD_DEVICE", {
          ...this.device,
          maxVoltage: +this.device.maxVoltage,
        })
        .then((response) => {
          $this.$swal({
            position: "bottom-end",
            icon: "success",
            title: "Uspješno ste dodali uređaj",
            showConfirmButton: false,
            timer: 1500,
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          $this.$router.push({ name: "DevicesIndex" });
        })
        .catch((error) => {
          if (error.data.message == "Device alredy exists")
            $this.deviceAlredyExists = true;
        });
    },
    updateDevice() {
      var $this = this;
      store
        .dispatch("devices/UPDATE_DEVICE", {
          ...this.device,
          maxVoltage: +this.device.maxVoltage,
        })
        .then((response) => {
          $this.$swal({
            position: "bottom-end",
            icon: "success",
            title: "Uspješno ste izmijenili podatke o uređaju",
            showConfirmButton: false,
            timer: 1500,
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          $this.$router.push({ name: "DevicesIndex" });
        })
        .catch((error) => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-alert {
  padding-bottom: 0;
}
.form-control:disabled {
  background-color: white;
}
#deviceId {
  font-weight: bold;
}
</style>
